import Style from 'molo-shared/lib/models/Style';

const MAX_ENTRIES = 15;
const TTL_MS = 10 * 60 * 1000;

interface CacheEntry {
    styles: Style[];
    fetchedAt: number;
}

const cache = new Map<string, CacheEntry>();

function segmentKey(value: string): string {
    if (!value) {
        return '';
    }
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

export function buildCollectionMastersCacheKey(
    orderType: string,
    collectionName: string,
    currencyCode: string,
    pricegroup: string
): string {
    return [
        segmentKey(orderType),
        segmentKey(collectionName),
        segmentKey(currencyCode),
        segmentKey(pricegroup),
    ].join('\u0001');
}

/** Returns cached styles or null if missing / expired. Refreshes LRU order on hit. */
export function getCachedCollectionMasters(key: string): Style[] | null {
    const entry = cache.get(key);
    if (!entry) {
        return null;
    }
    if (Date.now() - entry.fetchedAt > TTL_MS) {
        cache.delete(key);
        return null;
    }
    cache.delete(key);
    cache.set(key, entry);
    return entry.styles;
}

export function setCachedCollectionMasters(key: string, styles: Style[]): void {
    if (cache.has(key)) {
        cache.delete(key);
    }
    cache.set(key, { styles, fetchedAt: Date.now() });
    while (cache.size > MAX_ENTRIES) {
        const oldest = cache.keys().next().value as string;
        cache.delete(oldest);
    }
}

export function clearCollectionMastersCache(): void {
    cache.clear();
}
